// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39ZP6","colBig":"styles_colBig__2E7uq","colSmall":"styles_colSmall__2F013","shopifyNameWrapper":"styles_shopifyNameWrapper__j3GYF"};